module.exports = __webpack_public_path__ + "static/assets/c80022cd3424a0dc9635de89433cf08e.svg";